// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3txQ3","alert":"SettungsInbox_alert__z5GRX"};